var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvertimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5013_177356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.25H11.6875V13.3125H14.9375V12.5H12.5V9.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11.6875V8.4375L18.1062 9.33125C17.05 7.3 14.9375 6 12.5 6C8.925 6 6 8.925 6 12.5C6 16.075 8.925 19 12.5 19C14.45 19 16.2375 18.1062 17.375 16.725L16.1562 15.6687C15.2625 16.725 13.9625 17.375 12.5 17.375C9.81875 17.375 7.625 15.1812 7.625 12.5C7.625 9.81875 9.81875 7.625 12.5 7.625C14.45 7.625 16.1562 8.84375 16.9688 10.4688L15.75 11.6875H19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5013_177356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertimeIcon);
export default __webpack_public_path__ + "static/media/overtime-icon.7a7d62b28cc7b1479534c20a327528ae.svg";
export { ForwardRef as ReactComponent };